import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';

ErrorAlert.propTypes = {
  error: PropTypes.string,
};

function ErrorAlert(props) {
  const styleError = { minWidth: 150 };
  return props.error && <Alert style={styleError} showIcon closable type="error" message="Error" description={props.error} />;
}

export default ErrorAlert;



// WEBPACK FOOTER //
// ./src/components/ErrorAlert/index.js